import React from 'react';
import { styled } from '@compiled/react';
import Lozenge from '@atlaskit/lozenge';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { Link } from '@atlassian/react-resource-router';
import { messages as commonMessages } from '../../messages';
import { type CustomerAccess, CUSTOMER_ACCESS } from '../../types';
import messages from './messages';

type Props = {
	accessType: CustomerAccess;
	settingsLink: string;
};

export const CustomerAccessStatus = (props: Props) => {
	const { formatMessage } = useIntl();
	const { accessType, settingsLink } = props;

	const isOpenAccess = accessType !== CUSTOMER_ACCESS.RESTRICTED;

	const appearance = isOpenAccess ? 'success' : 'removed';
	const label = isOpenAccess
		? formatMessage(commonMessages.openLabel)
		: formatMessage(commonMessages.restrictedLabel);
	const content = isOpenAccess
		? messages.openAccessDescription
		: messages.restrictedAccessDescription;

	return (
		<>
			<Wrapper>
				<Lozenge appearance={appearance}>{label.toLocaleUpperCase()}</Lozenge>
				<Box xcss={descriptionStyles}>{formatMessage(content)}</Box>
			</Wrapper>
			<p>
				<Link href={settingsLink}>{formatMessage(messages.editCustomerPermissions)}</Link>
			</p>
		</>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	marginTop: token('space.150', '12px'),
});

const descriptionStyles = xcss({
	marginLeft: 'space.100',
});
